// assets/outfit-builder.js
document.addEventListener('DOMContentLoaded', function () {

  // Helper: fetch JSON product info by handle using storefront API alternate?
  // We'll use rendered product URLs present in data-attributes (safer).
  const modal = document.getElementById('outfit-builder-modal');
  const productsList = modal ? modal.querySelector('.ob-products-list') : null;
  const addAllBtn = modal ? modal.querySelector('.ob-add-all') : null;
  const viewAllLink = modal ? modal.querySelector('.ob-view-collection') : null;
  const closeBtn = modal ? modal.querySelector('.ob-modal__close') : null;

  function openModal(productHandles, productMeta) {
    if (!modal) return;
    // Clear
    productsList.innerHTML = '';

    // productMeta is a flattened string: "Title||/products/handle||Title2||/products/handle2||"
    const parts = productMeta ? productMeta.split('||').filter(Boolean) : [];
    // Build display list
    for (let i = 0; i < parts.length; i += 2) {
      const title = parts[i];
      const url = parts[i + 1] || '#';
      const handle = (productHandles[i/2] || '');
      const imgSrc = ''; // We will attempt to find product featured image via DOM (skip for now)

      const item = document.createElement('div');
      item.className = 'ob-product';

      const thumb = document.createElement('img');
      thumb.src = url + '?view=thumbnail'; // best-effort - fallback

      const meta = document.createElement('div');
      meta.className = 'ob-product__meta';
      meta.innerHTML = `<p class="ob-product__title">${title}</p>
                        <a class="ob-product__link" href="${url}">View product</a>`;

      item.appendChild(thumb);
      item.appendChild(meta);
      productsList.appendChild(item);
    }

    // Save handles in button dataset
    addAllBtn.dataset.handles = productHandles.join(',');
    viewAllLink.href = productHandles.length ? '/collections/all' : '/collections/all';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  // Event: click shop-outfit buttons
  document.querySelectorAll('.shop-outfit').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const handlesRaw = btn.dataset.products || '';
      const handles = handlesRaw.split(',').filter(Boolean);
      const meta = btn.dataset.productsMeta || '';
      openModal(handles, meta);
    });
  });

  // Close modal
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) modal.querySelector('.ob-modal__backdrop').addEventListener('click', closeModal);

  // Add all to cart (AJAX)
  if (addAllBtn) {
    addAllBtn.addEventListener('click', async function () {
      const handles = (this.dataset.handles || '').split(',').filter(Boolean);
      if (!handles.length) return;
      this.disabled = true;
      // For each handle, we need its product id and first variant id.
      // We'll fetch product JSON endpoints: /products/{handle}.js
      const variantIds = [];
      for (const h of handles) {
        try {
          const res = await fetch(`/products/${h}.js`);
          if (!res.ok) continue;
          const data = await res.json();
          // choose first available variant
          const variant = data.variants && data.variants.find(v => v.available) || data.variants && data.variants[0];
          if (variant) variantIds.push(variant.id);
        } catch (err) {
          console.warn('Error fetching product', h, err);
        }
      }

      // Add one by one (Shopify supports POST /cart/add.js)
      for (const vid of variantIds) {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          });
        } catch (err) {
          console.warn('Add to cart failed', err);
        }
      }

      // After adding, redirect to cart
      window.location.href = '/cart';
    });
  }
// Animate cards on scroll
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.2 });

document.querySelectorAll('.outfit-card').forEach(card => observer.observe(card));

});
